export default {
  'da cheng international asset management co. ltd': 'Da Cheng International Asset Management Co., Ltd.',
  'product': 'Product',
  'analysis report': 'Analysis Report',
  'resource': 'Resource',
  'me': 'Me',
  'login': 'Login',
  'logout': 'Logout',
  'username': 'Username',
  'password': 'Password',
  '{1} is required': '{1} is required',
  'service statement': 'Service Statement',
  'user profile': 'User Profile',
  'accept': 'Accept',
  'reject': 'Reject',
  'email': 'Email',
  'contact person': 'Contact Person',
  'phone no': 'Phone Number',
  'fax': 'Fax Number',
  'lanaguage': 'Preferred Language',
  'simplified chinese': 'Simplified Chinese',
  'traditional chinese': 'Traditional Chinese',
  'english': 'English',
  'save': 'Save',
  'the format of {1} is not correct': 'The format of {1} is not correct',
  'position': 'Position',
  'website': 'Official Website',
  'save successfully': 'Saved successfully',
  'save failed': 'Failed to save',
  'documents': 'Documents',
  'upload document': 'Upload Document',
  'file type to upload': 'File Type to Upload',
  'type one': 'Type One',
  'type two': 'Type Two',
  'type three': 'Type Three',
  'upload successfully': 'Uploaded successfully',
  'upload failed': 'Failed to upload',
  'yyyy-mm-dd hh:mm:ss': 'YYYY-MM-DD HH:mm:ss',
  'last updated': 'Last Updated',
  'file name': 'File Name',
  'status': 'Status',
  'uploaded': 'Uploaded',
  'accepted': 'Accepted',
  'rejected': 'Rejected',
  'home phone': 'Home Phone',
  'mobile phone': 'Mobile Phone',
  'office phone': 'Office Phone',
  'employment': 'Employment',
  'employed': 'Employed',
  'self-employed': 'Self-Employed',
  'retired': 'Retired',
  'others': 'Others',
  'remark': 'Remark',
  'country': 'Country',
  'china': 'China',
  'hong kong': 'Hong Kong SAR, China',
  'employer': 'Employer',
  'products': 'Products',
  'introduction': 'Introduction',
  'performance': 'Performance',
  'please select product': 'Please Select Product',
  'analysis reports': 'Analysis Reports',
  'download': 'Download',
  'all products': 'All Products',
  'report name': 'Report Name',
  'report': 'Report',
  'report type': 'Report Type',
  'operation': 'Operation',
  'all types': 'All Types',
  'readed': 'Readed',
  'unread': 'Unread',
  'prev': 'Previous',
  'next': 'Next',
  'search': 'Search',
  'language': 'Language',
  'no data': 'No Data',
  'upload': 'Upload Document',
  'resources': 'Resources',
  'resource name': 'Resource Name',
  'name': 'Name',
  'resource type': 'Resource Type',
  'user account is locked': 'User account is locked',
  'bad credentials': 'Username or password is not correct',
  'period': 'Period',
  '1 month': '1 Month',
  '3 months': '3 Months',
  '1 year': '1 Year',
  '3 years': '3 Years',
  'all': 'Since Inception',
  'statistics': 'Statistics',
  'indexes': 'Indexes',
  'comparable indexes': 'Comparable Indexes',
  'the page does not exist': 'The page does not exist',
  'change password': 'Change Password',
  'old pass': 'Old Password',
  'new pass': 'New Password',
  'confirm': 'Confirm Password',
  'new password': 'New Password',
  'your password is expired, please change your password.': 'Your password has expired, please change your password.',
  'change': 'Change',
  'cancel': 'Cancel',
  'length of new password must be 8 to 30': 'Length of new password must be 8 to 30',
  'new password and confirm password should be the same': 'New password and confirm password should be the same',
  'password update successfully': 'Password updated successfully',
  'password update failed, please make sure the old password is correct': 'Failed to update password, please make sure the old password is correct',
  '* please upload pdf, word, excel, png or jpg file. the maximum file size is 5mb.': '* Supported file types: PDF, Word, Excel, PNG or JPEG. Maximum file size is 5MB.',
  'activate account': 'Activate Account',
  'the activate link is invalid or expired': 'The activation link is invalid or expired',
  'account activate successfully': 'Account activated successfully',
  'account activate failed. please make sure the link is valid': 'Failed to activate account, please make sure the link is valid',
  'forget password?': 'Forget Password?',
  'please enter the username': 'Please enter the username',
  'find password': 'Retrieve Password',
  'find password failed. please make sure the username is correct': 'Failed to retrieve password, please make sure the username is correct',
  'the reset password link is sent to your email. please use the link to reset your password': 'The reset password link has been sent to your email. Please use the link to reset your password',
  'reset password': 'Reset Password',
  'the reset password link is invalid or expired': 'The reset password link is invalid or expired',
  'password reset successfully': 'Password reset successfully',
  'password reset failed. please make sure the link is valid': 'Failed to reset password, please make sure the link is valid',
  'new email': 'New Email',
  'the format of email is not correct': 'The format of email is not correct',
  'the activate link is sent to your new email address. please use the link to activate the new email': 'The activation link has been sent to your new email. Please use the link to activate the new email',
  'change email': 'Change Email',
  'change email failed, please make sure the email is correct': 'Failed to change email, please make sure the email is correct',
  'ok': 'OK',
  'activate new email': 'Activate New Email',
  'the new email is activated successfully.': 'The new email has been activated successfully.',
  'activate new email failed. please make sure the link is valid.': 'Failed to activate new email, please make sure the link is valid.',
  'download selected': 'Download Selected',
  'privacy': 'Privacy Statement',
  'dci asset management company limited., all rights reserved.': 'DCI Asset Management Company Limited. All rights reserved.',
  'dc fund': 'Da Cheng Fund',
  'by clicking "login", you agree to ': 'By clicking "Login", you agree to ',
  'our privacy statement': 'our privacy statement',
  'id/passport no': 'ID / Passport No.',
  'if changing this field, please provide supporting documents': 'If changing this field, please contact your relationship manager and provide supporting documents.',
  'chinese name': 'Chinese Name',
  'english name': 'English Name',
  'nationality': 'Nationality',
  'birthday': 'Birthday',
  'country of birth': 'Country of Birth',
  'residential address': 'Residential Address',
  'business address': 'Business Address',
  'type': 'Type',
  'disclaimer': 'Disclaimer',
  'disclaimer-content': 'This material is issued by Da Cheng International Asset Management Co., Ltd. ("DCI") and has not been reviewed by the SFC. Investments are subject to investment risks. Investors should not make any investment decision solely based on this document. Any opinion or estimate contained in this document is made on a general basis and is not to be relied on by the investor as advice. Investors should not invest in the Fund unless the intermediary who sells it to you has explained that the Fund is suitable for you. Investors should read the Fund\'s Explanatory Memorandum / Offering Document / Product Key Facts Statement / Risk Factors before making any investment decision. Copies of the Offering Documents can be obtained at DCI\'s Hong Kong Office (Tel: +852 3765 6788) or offices of the participating distributors. The value of units may go down as well as up. Past performance is not indicative of future performance. DCI, its associates or its distributors accept no responsibility and do not guarantee the return of the Fund. DCI endeavors to ensure the accuracy and reliability of the information provided in this material and guarantees its accuracy or reliability and does not accept liability for any loss or damage arising from any inaccuracies or omissions. All documents must not be copied, reproduced or provided for third parties without the permission of DCI.',
  'disclaimer-data-content': 'DCI endeavors to ensure the accuracy and reliability of the information provided in this material, but does not guarantee its accuracy, reliability or completeness. DCI does not accept liability for any loss or damage arising from any inaccuracies or omissions.',
  'the email exists in the system. please use another email': 'The email already exists in the system. Please use another email.',
  'net value': 'Net Value',
  'cumulative returns': 'Cumulative Returns',
  'annualized returns': 'Annualized Returns',
  'annualized volatility': 'Annualized Volatility',
  'information ratio': 'Information Ratio',
  'max drawdown': 'Max Drawdown',
  "i've read the notice aboved": 'I have read the above notice',
  'company name': 'Company Name',
  'ci no': 'Company Registration No.',
  'registration area': 'Registration Area',
  'registration date': 'Registration Date',
  'business type': 'Business Type',
  'registration address': 'Registration Address',
  'please select file type': 'Please Select File Type',
  'dial code': 'Dial Code',
  '{1} and area code should both exist or not exist': '{1} and area code should both exist or be empty',
  'this portal is for client only, for manager and compliance users, please use admin portal.': 'This portal is for client use only. If you are a relationship manager or compliance user, please use the admin portal.',
  'download net value': 'Download Net Value',
  'uploading the document, please wait': 'Uploading the document, please wait',
  'captcha': 'Captcha',
  'imageid is blank': 'Captcha is invalid',
  'code is blank': 'Captcha is required',
  'code is not matched': 'Captcha is incorrect',
  'code is expired': 'Captcha has expired',
  'position details': 'Position Details',
  'total position market value (Hong Kong Dollar)': 'Total Market Value (Hong Kong Dollar)',
  'total position cost (Hong Kong Dollar)': 'Total Position Cost (Hong Kong Dollar)',
  'position fund count': 'Fund Count',
  'floating profit/loss (Hong Kong Dollar)': 'Position P/L (Hong Kong Dollar)',
  'cumulative return rate': 'Position Return Rate',
  'position date': 'NAV Date',
  'fund name': 'Fund Name',
  'base currency': 'Base Currency',
  'household registration number': 'Account Number',
  'fund category': 'Share Class',
  'fund category currency': 'Share Currency',
  'position quantity': 'Quantity',
  'cost price': 'Unit Cost',
  'net asset value per unit': 'Net asset value per unit of fund',
  'position cost (Hong Kong Dollar)': 'Position Cost (Hong Kong Dollar)',
  'position cost': 'Position Cost Value',
  'position market value (Hong Kong Dollar)': 'Market Value (Converted HKD)',
  'position market value': 'Market Value',
  'converted market value': 'Converted Value',
  'floating profit/loss': 'Position P/L',
  'profit/loss rate': 'Position Return Rate',
  'position ratio': 'Position Ratio',
  'account': 'Account',
  'please select account': 'Please Select Account',
  'export report': 'Export Report',
  'query': 'Query',
  'total records': 'Total {1} Records',
  'first page': 'First',
  'last page': 'Last',
  'float profit/loss and return rate are calculated based on data since 2014.': 'Floating profit/loss and return rate are calculated based on data since 2014.',
  'position return rate tooltip': 'The overall cumulative return rate of all position funds under the current account. Formula: (Total Position P/L ÷ Total Position Cost) × 100%.',
  'cost price, floating profit/loss and return rate are calculated based on data since 2014.': 'Cost price, floating profit/loss and return rate are calculated based on data since 2014.',
  'holdings': 'Holdings',
  'transactions': 'Transactions',
  'transaction date': 'Transaction Date',
  'transaction tranNo': 'Transaction TranNo',
  'transaction type': 'Transaction Type',
  'amount': 'Amount',
  'shares': 'Shares',
  'net value (txn)': 'NAV',
  'fee': 'Fee',
  'transaction number': 'Transaction No.',
  'buy': 'Buy',
  'sell': 'Sell',
  'no holdings data': 'No holdings data',
  'no transactions data': 'No transactions',
  'product information only for reference': 'The following product information is for reference only. Actual product information is subject to the relevant agreements signed between the investor and the manager.',
  'fund code': 'Fund Code',
  'fund class': 'Fund Class',
  'total market value': 'Total Market Value',
  'data cutoff value': 'Data Cutoff ',
  'yesterday return': 'Yesterday Return',
  'holding profit/loss': 'Holding P/L',
  'cumulative profit/loss': 'Cumulative P/L',
  'performance trend': 'Performance',
  '6 months': '6M',
  'position': 'Position',
  'time range': 'Time Range',
  'start date': 'Start Date',
  'end date': 'End Date'
}
